<file-pond
  #myPond
  [options]="pondOptions"
  (onprocessfile)="pondHandleProcessFile($event)"
  (onremovefile)="pondHandleRevertFile($event)"
  [files]="pondFiles"
>
</file-pond>
